<div class="property-data-container">
    <div class="container header">
        <div class="row h-100">
            <div class="col-sm-6 title">
                <label>PROPERTY DATA FORM</label>
            </div>
            <div *ngIf="isEditing"
                 class="col-sm-6 add-btn text-right">

                <button type="button"
                        class="btn btn-save btn-primary btn-small"
                        [disabled]="isSavingInProcess || isPristine || !formIsValid"
                        (click)="saveChanges()"
                        tabindex="17">
                    SAVE INFO
                    <i *ngIf="isSavingInProcess"
                       class="fas fa-spinner fa-spin"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="container">
		<div class="row mb-4 form-section">
            <div class="col">
				<h5 class="section-title">Property Data Collection</h5>
				<div class="row">
					<div class="col-sm-4">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.propertyDataCollectorName',
								editable: viewPropertyCollectorFields
							}"
							[indexTab]="0">
						</cv-schema-render-form-field>
					</div>
					<div class="col-sm-4">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.propertyDataCollectorType',
								editable: viewPropertyCollectorFields
							}"
							[indexTab]="0">
						</cv-schema-render-form-field>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.parties[0].phone',
								editable: viewPropertyCollectorFields
							}"
							[indexTab]="0">
						</cv-schema-render-form-field>
					</div>
					<div class="col-sm-4">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.parties[0].email',
								editable: viewPropertyCollectorFields
							}"
							[indexTab]="0">
						</cv-schema-render-form-field>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.parties[0].credentialId',
								editable: false
							}"
							[indexTab]="0">
						</cv-schema-render-form-field>
					</div>
					<div class="col-sm-4">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.parties[0].credentialExpDate',
								editable: false
							}"
							[indexTab]="0">
						</cv-schema-render-form-field>
					</div>
					<div class="col-sm-4">
						<cv-schema-render-form-field
							[options]="{
								path: 'InspectionReport.parties[0].credentialState',
								editable: false
							}"
							[indexTab]="0">
						</cv-schema-render-form-field>
					</div>
				</div>
			</div>
		</div>
        <div class="row mb-4 form-section address-list">
            <div class="col">
                <h5 class="section-title">Order Details</h5>
                <div class="row">
					<div class="col-sm-6">
                        <cv-schema-render-form-field  class="address-trigger"
                            [options]="{
                                path: [
									'InspectionReport.property.address.streetAddress',
									'InspectionReport.property.address.city',
									'InspectionReport.county',
									'InspectionReport.property.address.state',
									'InspectionReport.property.address.postalCode',
								],
                                displayType:'PublicRecord',
                                label:'Address',
								charConcat: ', ',
                                triggerModal:true,
                                publicRecordType:'trigger',
                                publicRecordMultiple: this.data.publicRecords,
                                orderId: this.data.order.id,
                                orderDescription: this.data.order.description
                            }">
                        </cv-schema-render-form-field>
                    </div>
                    <div class="col-sm-4">
                        <cv-schema-render-form-field
                            [options]="{
                                path: 'InspectionReport.scanDate',
                                displayType:'PublicRecord',
                                label:'Inspection Date',
                                pipe:'date'
                            }">
                        </cv-schema-render-form-field>
                    </div>
                    <!-- <div class="col-sm-3">
                        <cv-schema-render-form-field
                        [options]="{
                                path: 'InspectionReport.borrower',
                                displayType:'PublicRecord',
                                label:'Borrower'
                        }">
                        </cv-schema-render-form-field>
                    </div> -->
                </div>

				<div class="row mt-3" *ngIf="isEditing">
					<div class="col-sm-3">
						<cv-schema-render-form-field
                            [options]="{
                                path: 'InspectionReport.property.address.streetAddress',
								label:'Modify Street Address'
                            }"
							[indexTab]="1">
                        </cv-schema-render-form-field>
					</div>
                    <!-- <div class="col-sm-2">
						<cv-schema-render-form-field
                            [options]="{
                                path: 'InspectionReport.property.address.streetAddress',
								label:'Modify Street Address2'
                            }"
							[indexTab]="2">
                        </cv-schema-render-form-field>
					</div> -->
                    <div class="col-sm-3">
						<cv-schema-render-form-field
                            [options]="{
                                path: 'InspectionReport.property.address.city'
                            }"
							[indexTab]="3">
                        </cv-schema-render-form-field>
					</div>
					<div class="col-sm-3">
						<cv-schema-render-form-field
                            [options]="{
                                path: 'InspectionReport.county'
                            }"
							[indexTab]="3">
                        </cv-schema-render-form-field>
					</div>
                    <div class="col-sm-2">
						<cv-schema-render-form-field
                            [options]="{
                                path: 'InspectionReport.property.address.state'
                            }"
							[indexTab]="4">
                        </cv-schema-render-form-field>
					</div>
                    <div class="col-sm-1">
						<cv-schema-render-form-field
                            [indexTab]="5"
                            [options]="{
                                path: 'InspectionReport.property.address.postalCode',
                                onlyDigits: true,
                                min: 0,
                                max: 99999,
                                required: true,
                                validators: ['required', 'digits:5']
                            }">
                        </cv-schema-render-form-field>
					</div>
				</div>
            </div>
        </div>
        <div class="row mb-4 form-section">
            <div class="col">
                <h5 class="section-title">Property Characteristics
                    <span class="message-public-record">
                        {{PUBLIC_RECORD_MESSAGES[data.publicRecords]}}
                    </span>
				</h5>
                <div class="row">
                    <div class="col-sm-4">
                        <cv-schema-render-form-field
                        [options]="{
                                path: 'InspectionReport.property.propertyAnalysis.propertyType'
                        }"
                        [indexTab]="1">
                        </cv-schema-render-form-field>
                    </div>
                    <div class="col-sm-4">
                        <cv-schema-render-form-field
                        [options]="{
                                path: 'InspectionReport.property.propertyAnalysis.locationType'
                        }"
                        [indexTab]="2">
                        </cv-schema-render-form-field>
                    </div>
                    <div class="col-sm-4">
                        <cv-schema-render-form-field
                        [options]="{
                                path: 'InspectionReport.property.propertyAnalysis.occupantType'
                        }"
                        [indexTab]="3">
                        </cv-schema-render-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <cv-schema-render-form-field
                            [indexTab]="4"
                            [options]="{
                                path: 'InspectionReport.property.site.lot.lotSize',
                                onlyDigits: true,
                                min: 0,
                                max: 99999999,
                                postfix:'ft2',
                                publicRecordMultiple: this.data.publicRecords
                            }">
                        </cv-schema-render-form-field>
                    </div>
                    <div class="col-sm-4">
                        <cv-schema-render-form-field
                        [options]="{
                                path: 'InspectionReport.property.propertyAnalysis.propertyConditionRating'
                        }"
                        [indexTab]="5">
                        </cv-schema-render-form-field>
                    </div>
                    <div class="col-sm-4">
                        <cv-schema-render-form-field
                        [options]="{
                                path: 'InspectionReport.property.propertyAnalysis.propertyQualityRating'
                        }"
                        [indexTab]="6">
                        </cv-schema-render-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <cv-schema-render-form-field
                        [options]="{
                                path: 'InspectionReport.property.propertyAnalysis.yearsOwned',
                                onlyDigits: true,
                                min: 0,
                                max: 999,
                                postfix:'years',
                                publicRecordMultiple: this.data.publicRecords
                        }"
                        [indexTab]="7">
                        </cv-schema-render-form-field>
                    </div>
                    <div class="col-sm-4">
                        <cv-schema-render-form-field
                        [options]="{
                                path: 'InspectionReport.property.propertyAnalysis.unitFee',
                                onlyDigits: true,
                                min: 0,
                                max: 99999999,
                                postfix:'USD',
                                prefix:'$'
                        }"
                        [indexTab]="8">
                        </cv-schema-render-form-field>
                    </div>
                    <div class="col-sm-4">
                        <cv-schema-render-form-field
                        [options]="{
                                path: 'InspectionReport.property.propertyAnalysis.unitFeePeriodType'
                        }"
                        [indexTab]="9">
                        </cv-schema-render-form-field>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-4 form-section">
            <div class="col metrics-list">
                <cv-schema-render-form-field
                [options]="{
                    path: 'InspectionReport.property.cv_Metrics.aboveGrade.gla',
                    displayType:'PublicRecord',
                    label:'Above Grade Total/GLA (SF)'
                }">
                </cv-schema-render-form-field>

                <cv-schema-render-form-field
                [options]="{
                    path: 'InspectionReport.property.cv_Metrics.aboveGrade.rooms',
                    displayType:'PublicRecord',
                    label:'Rooms'
                }">
                </cv-schema-render-form-field>

                <cv-schema-render-form-field
                [options]="{
                    path: 'InspectionReport.property.cv_Metrics.aboveGrade.bedrooms',
                    displayType:'PublicRecord',
                    label:'Bedrooms'
                }">
                </cv-schema-render-form-field>

                <cv-schema-render-form-field
                [options]="{
                    path: ['InspectionReport.property.cv_Metrics.aboveGrade.fullBathrooms', 'InspectionReport.property.cv_Metrics.aboveGrade.halfBathrooms'],
                    displayType:'PublicRecord',
                    label:'Bathrooms',
                    charConcat:'.'
                }">
                </cv-schema-render-form-field>
            </div>
        </div>

        <div class="row mb-4 form-section">
            <div class="col metrics-list">
                <cv-schema-render-form-field
                [options]="{
                    path: ['InspectionReport.property.cv_Metrics.belowGrade.total', 'InspectionReport.property.cv_Metrics.belowGrade.finished'],
                    displayType:'PublicRecord',
                    label:'Below Grade Total/Finished (SF)'
                }">
                </cv-schema-render-form-field>

                <cv-schema-render-form-field
                [options]="{
                    path: 'InspectionReport.property.cv_Metrics.belowGrade.recRooms',
                    displayType:'PublicRecord',
                    label:'Rec. Room'
                }">
                </cv-schema-render-form-field>

                <cv-schema-render-form-field
                [options]="{
                    path: 'InspectionReport.property.cv_Metrics.belowGrade.bedrooms',
                    displayType:'PublicRecord',
                    label:'Bedrooms'
                }">
                </cv-schema-render-form-field>

                <cv-schema-render-form-field
                [options]="{
                    path: ['InspectionReport.property.cv_Metrics.belowGrade.fullBathrooms', 'InspectionReport.property.cv_Metrics.belowGrade.halfBathrooms'],
                    displayType:'PublicRecord',
                    label:'Baths',
                    charConcat:'.'
                }">
                </cv-schema-render-form-field>

                <cv-schema-render-form-field
                [options]="{
                    path: 'InspectionReport.property.cv_Metrics.belowGrade.othersRooms',
                    displayType:'PublicRecord',
                    label:'Other'
                }">
                </cv-schema-render-form-field>
            </div>
        </div>

        <div class="row mb-4 form-section">
            <div class="col">
                <h5 class="section-title">Utilities</h5>

                <div class="row">
                    <div class="col">
                        <cv-schema-render-form-field-special
                        [options]="{
                            path: 'InspectionReport.property.site.siteUtility.sewerServices',
                            showEnumValues: {
                                key: 'serviceType'
                            },
                            category:'Sewer'
                        }"
                        [indexTab]="10">
                        </cv-schema-render-form-field-special>
                    </div>

                    <div class="col">
                        <cv-schema-render-form-field-special
                        [options]="{
                            path: 'InspectionReport.property.site.siteUtility.waterServices',
                            showEnumValues: {
                                key: 'serviceType'
                            },
                            category:'Water'
                        }"
                        [indexTab]="11">
                        </cv-schema-render-form-field-special>
                    </div>

                    <div class="col">
                        <cv-schema-render-form-field-special
                        [options]="{
                            path: 'InspectionReport.property.site.siteUtility.electricalServices',
                            showEnumValues: {
                                key: 'serviceType'
                            },
                            category:'Electrical'
                        }"
                        [indexTab]="12">
                        </cv-schema-render-form-field-special>
                    </div>
                    <div class="col">
                        <cv-schema-render-form-field-special
                        [options]="{
                            path: 'InspectionReport.property.site.siteUtility.fuelServices',
                            showEnumValues: {
                                key: 'serviceType'
                            },
                            category:'Gas'
                        }"
                        [indexTab]="13">
                        </cv-schema-render-form-field-special>
                    </div>
                </div>

            </div>
        </div>

        <ng-container *ngFor="let structure of data.structures; let i = index">
            <div class="row mb-4 form-section">
                <div class="col">
                    <h5 class="section-title">{{structure.cv_Label}}</h5>
                    <div class="row">
                        <div class="col">
                            <cv-schema-render-form-field
                            [options]="{
                                path: 'InspectionReport.property.structures[' + i + '].constructionType'
                            }"
                            [indexTab]="14">
                            </cv-schema-render-form-field>
                        </div>
                        <div class="col">
                            <cv-schema-render-form-field
                            [options]="{
                                path: 'InspectionReport.property.structures[' + i + '].yearBuilt',
                                onlyDigits: true,
                                min: 0,
                                max: 9999,
                                publicRecordMultiple: i == 0 ? this.data.publicRecords : null
                            }"
                            [indexTab]="15">
                            </cv-schema-render-form-field>
                        </div>
                        <div class="col">
                            <cv-schema-render-form-field
                            [options]="{
                                path: 'InspectionReport.property.structures[' + i + '].yearBuiltEstimate'
                            }"
                            [indexTab]="16">
                            </cv-schema-render-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<cv-public-record-single *ngIf="this.data.publicRecords === 'single'"
						[publicRecordType]="this.data.publicRecords">
</cv-public-record-single>
